export function lockScroll() {
    const scrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -(scrollPosition) + 'px';
    localStorage.setItem('scrollLockPosition', scrollPosition);
}

export function unlockScroll() {
    const scrollPosition = localStorage.getItem('scrollLockPosition') || 0;
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');

    window.scrollTo({
        top: scrollPosition,
        behavior: 'instant',
    });
}
